// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"460":"6d994624a561f0f3","574":"307bad1ba353f0d1","757":"e13f9c9dba357c96"}[chunkId] + ".js";
};